import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AttachmentResponse } from 'src/app/shared/model/attachment-response.model';
import { IAppConfig } from '../Config/app-config.model';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsService {
  popupTitle: string;
  popupMessage: string;

  private attachmentsSubject = new Subject<AttachmentResponse[]>();
  isAttachmentsSavedToDb: boolean = true;

  constructor(private _httpClient: HttpClient, @Inject('appconfig') private configParam: IAppConfig) { }

  publishAttachments(data: AttachmentResponse[]): void {
    this.attachmentsSubject.next(data);
  }

  getAttachments(): Observable<AttachmentResponse[]> {
    return this.attachmentsSubject.asObservable();
  }

  getAttachment(fileServiceId: string): Observable<any> {
    const url = `${this.configParam.ApiConfig.ATTACHMENT_API_ENDPOINT}Attachment/${fileServiceId}`;
    return this._httpClient.get(url, { responseType: 'blob' });
  }

  getPdfAttachment(fileServiceId: string): Observable<any> {
    const url = `${this.configParam.ApiConfig.ATTACHMENT_API_ENDPOINT}Attachment/${fileServiceId}`;
    return this._httpClient.get(url, { responseType: 'blob' }).pipe(map(
      (res) => {
        return new Blob([res], { type: 'application/pdf' });
      }));
  }

  GetAttachmentListByPublicationHistoryId(publicationHistoryId: string): Observable<Array<AttachmentResponse>> {
    return this._httpClient.get<Array<AttachmentResponse>>(
      `${this.configParam.ApiConfig.API_ENDPOINT}Attachment/ListByPublicationHistoryId/${publicationHistoryId}`);
  }

  GetAttachmentListBySubmittalId(submittalId: string): Observable<Array<AttachmentResponse>> {
    return this._httpClient.get<Array<AttachmentResponse>>(
      `${this.configParam.ApiConfig.API_ENDPOINT}Attachment/ListBySubmitalId/${submittalId}`);
  }

  setTitle(title: string) {
    this.popupTitle = title;
  }

  setMessage(msg: string) {
    this.popupMessage = msg;
  }

  getTitle() {
    return this.popupTitle == undefined ? "" : this.popupTitle;
  }
  
  getMessage() {
    return this.popupMessage == undefined ? "" : this.popupMessage;
  }
}
